import { gql } from '@apollo/client';

export const GET_QUESTIONNAIRES_QUERY = gql`
  query getQuestionnairesQuery($id: String) {
    questionnaires(id: $id) {
      id
      created
      deleted
      modified
      name
      description
      version
      kpi_groups {
        id
        created
        deleted
        modified
        name
        description
      }
      kpis {
        id
        created
        deleted
        modified
        name
        description
        order
        kpi_group {
          id
        }
      }
      questions {
        id
        created
        deleted
        modified
        name
        description
        allowed_classifications
        categories
        compliance_references
        guidance_feedback
        order
        sdg_references
        kpi {
          id
        }
      }
    }
  }
`;
